export enum RoutePath {
  login = "/login",
  authHandleToken = "/authHandleToken",
  logout = "/logout",
  forgot = "/password/forgot",
  reset = "/password/reset",
  cases = "/cases",
  messaging = "/messaging",
  statuses = "/statuses",
  ift = "/ift",
  iftReports = "/iftReports",
  mih = "/mih",
  mihReports = "/mihReports",
  setNewPassword = "/set-new-password",
}
